/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { GetWithdrawalSecretsQueryResponse, GetWithdrawalSecrets400, GetWithdrawalSecrets403 } from '../entities/GetWithdrawalSecrets'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { getWithdrawalSecrets } from '../api/getWithdrawalSecrets'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getWithdrawalSecretsQueryKey = () => [{ url: '/withdrawal-secrets' }] as const

export type GetWithdrawalSecretsQueryKey = ReturnType<typeof getWithdrawalSecretsQueryKey>

export function getWithdrawalSecretsQueryOptions(config: Partial<RequestConfig> & { client?: typeof client } = {}) {
  const queryKey = getWithdrawalSecretsQueryKey()
  return queryOptions<
    GetWithdrawalSecretsQueryResponse,
    ResponseErrorConfig<GetWithdrawalSecrets400 | GetWithdrawalSecrets403>,
    GetWithdrawalSecretsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return getWithdrawalSecrets(config)
    },
  })
}

/**
 * @description Получение списка api-ключей вывода средств для таксопарка
 * @summary Получение списка api-ключей вывода средств для таксопарка
 * {@link /withdrawal-secrets}
 */
export function useGetWithdrawalSecrets<
  TData = GetWithdrawalSecretsQueryResponse,
  TQueryData = GetWithdrawalSecretsQueryResponse,
  TQueryKey extends QueryKey = GetWithdrawalSecretsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetWithdrawalSecretsQueryResponse,
        ResponseErrorConfig<GetWithdrawalSecrets400 | GetWithdrawalSecrets403>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof client }
  } = {},
) {
  const { query: { client: queryClient, ...queryOptions } = {}, client: config = {} } = options ?? {}
  const queryKey = queryOptions?.queryKey ?? getWithdrawalSecretsQueryKey()

  const query = useQuery(
    {
      ...(getWithdrawalSecretsQueryOptions(config) as unknown as QueryObserverOptions),
      queryKey,
      ...(queryOptions as unknown as Omit<QueryObserverOptions, 'queryKey'>),
    },
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<GetWithdrawalSecrets400 | GetWithdrawalSecrets403>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}